import { sanityClient } from "./sanityClient";

const localeStringProjection = "{ka, en}";
const localeTextProjection = "{ka, en}";

const listProjection = `{
  "year": year,
  kicker ${localeStringProjection},
  title ${localeStringProjection},
  excerpt ${localeTextProjection},
  tags ${localeStringProjection},
  "upcoming": comingSoon,
  coverImage
}`;

const postProjection = `{
  "year": year,
  kicker ${localeStringProjection},
  title ${localeStringProjection},
  bylineName ${localeStringProjection},
  bylineRole ${localeStringProjection},
  bylinePhoto,
  coverImage,
  "paragraphs": body[] ${localeTextProjection},
  hasWinners,
  winnersTitle ${localeStringProjection},
  winnersNote ${localeTextProjection},
  "winners": winners[] { category ${localeStringProjection}, name ${localeStringProjection} },
  hasJury,
  juryTitle ${localeStringProjection},
  juryMemberLabel ${localeStringProjection},
  "jury": jury[] { name ${localeStringProjection}, photo },
  hasGallery,
  galleryKicker ${localeStringProjection},
  galleryTitle ${localeStringProjection},
  gallery
}`;

export async function fetchBlogList() {
  return sanityClient.fetch(
    `*[_type == "post"] | order(year desc) ${listProjection}`
  );
}

export async function fetchBlogPost(year) {
  return sanityClient.fetch(
    `*[_type == "post" && year == $year][0] ${postProjection}`,
    { year }
  );
}
